import React from 'react';
import { connect } from 'react-redux'
import { strings } from "../../../constants/strings";

class FAQ extends React.Component {

  constructor(props) {
    super(props);

    var faqStructure = [];
    var parsedString;

    for (let i = 1; (("Category_" + i + "_Name") in strings); i++) {
      let categoryHeader = strings["Category_" + i + "_Name"]
      if(strings["Category_" + i + "_Name"] == ''){
          continue
      }
      var categoryQuestions = [];
      for (let j = 1; j <= 25; j++) {
        if(strings["Category_" + i + "_Question_" + j] == '' || strings["Category_" + i + "_Question_" + j] == undefined){
          continue
        }
        const regexForQuestions = /\*(.*)\*(.*)/;
        const regexForHttps = /(https?:\/\/[^\s]+)/gm;
        let replacedStr = strings["Category_" + i + "_Question_" + j].replaceAll('\n','<br>')
        const parsedLinks = replacedStr.match(regexForHttps)
        if(parsedLinks != null){
           parsedLinks.map( (link) => {
            replacedStr = replacedStr.replace(link, "<a href=" + link + ">" + link + "</a>")
           })
          parsedString = replacedStr.match(regexForQuestions);
        }
        else {
          parsedString = replacedStr.match(regexForQuestions);
        }

        let categoryQuestion = {
          header: parsedString[1],
          body: parsedString[2]
        }
        categoryQuestions.push(categoryQuestion)
      }
      let categoryObject = {
        header: categoryHeader,
        questions: categoryQuestions
      }
      faqStructure.push(categoryObject);
    }
    this.state = { faqStructure: faqStructure };
  }

  render() {
    document.body.style.backgroundColor = "white";
    document.body.style.backgroundImage = "none";
    return (
      <>
        <div className='faq-container'>
          <div id="html_news" className="row">
            <h2 className="col-sm">{strings["Info_faq"]}</h2>
            <div className="search-box col-sm">
              <div className="search-text">{strings["FAQ_Search_Text"]} </div>
              <div className="search-input">
                <input type="text" name="q" id="searchContent" className="inputbox" />
              </div>
            </div>
          </div>
          <ul id='posts'>
            {this.state.faqStructure.map((category, index) => (
              <div className='category'>
                <div className='category-header'>
                  {category.header}
                </div>
                <div className='category-content'>
                <div className='size-handler'>
                  {category.questions.map((question) => (                    
                      <div>
                        <strong>{question.header}</strong>
                        <br />
                        <span dangerouslySetInnerHTML={{__html: question.body}}></span>
                        <hr className="hrandroid" />
                      </div>                    
                  ))}
                  </div>
                </div>
              </div>
            ))}
          </ul>
        </div>
      </>
    );
  }
}
export default connect(/*mapStateToProps, mapDispatchToProps*/)(FAQ)